import { css } from '@emotion/react';
import { theme } from 'styles/theme/theme';

export const modalInputStyle = css`
  caret-color: ${theme.colors.AccentNaplesYellow};
  background-color: ${theme.colors.GrayF2};
  border: 1px solid transparent;
  max-height: 36px !important;
`;

/**
 * Только раскладка кнопки футера модалки: её надевают на `UDButton variant="primary"`. Цвета, шрифт, отступы, радиус
 * и вид disabled / loading — китовые: свои перебивали `.primary`, и выключенная кнопка выглядела не как в ките
 * (IMGM-1561).
 */
export const modalButton = css`
  width: 130px;
  min-width: 130px;
  height: 100%;
  gap: 10px;
`;

export const modalError = css`
  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${theme.colors.error};
`;
